/**
 * @voltxampere/ui — 4001 quad NOR CMOS variant (Sprint 41-5)
 *
 * CMOS sibling of the 7402 NOR. V_DD-rail-to-rail output (vHigh = 5,
 * vLow = 0) with the threshold at the 0.5×V_DD midpoint. Reuses the
 * op-amp triangle SVG; canonical "digital-gate" engine type per
 * ADR-0061.
 *
 * Reference: TI CD4001.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic4001 = {
    id: "4001",
    nameTr: "4001 (4'lü NOR CMOS, DIP-14)",
    nameEn: "4001 (Quad NOR CMOS, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "4001",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOR",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 100e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-4001.js.map